import VueEventer from "vue-eventer";
window.EventBus = new VueEventer();
